import { Component } from '@angular/core';

@Component({
  selector: 'app-change-username-success',
  templateUrl: './change-username-success.component.html',
  styleUrl: './change-username-success.component.scss',
  standalone: false
})
export class ChangeUsernameSuccessComponent {

}
